import React from 'react';
import IndustryDetailPage from './IndustryDetailPage.jsx';

function TestimonialWarehouse() {
  return <IndustryDetailPage industry="warehouse" />;
}

export default TestimonialWarehouse;
